import { DEFAULT_ASSET_LATITUDE, DEFAULT_ASSET_LONGITUDE } from '../constants/assetDefaultGeo';
import {
  ASSET_CREATE_CONTACT_EMAIL,
  ASSET_CREATE_CONTACT_PHONE,
} from '../constants/assetCreateContactDefaults';
import { buildDefaultAssetCreateOpeningTimes } from '../utils/openingTimesLocale';

/**
 * Default JSON bodies from `C:\\Users\\donny\\testings\\assets\\registerassets.js`
 * and `updateasset.js` for the Assets menu create/update fields.
 */
export const DEFAULT_ASSET_CREATE_BODY: Record<string, unknown> = {
  asset_name: 'Modern Office new very very long name',
  sub_title: '',
  address: {
    street: '456 Business St',
    building: '12',
    city: 'New York',
    zip_code: '10001',
    address2: 'Suite 100',
  },
  country_id: 1,
  state_id: 1,
  asset_type_id: 2,
  latitude: DEFAULT_ASSET_LATITUDE,
  longitude: DEFAULT_ASSET_LONGITUDE,
  min_capacity: null,
  max_capacity: null,
  phone_number: ASSET_CREATE_CONTACT_PHONE,
  email: ASSET_CREATE_CONTACT_EMAIL,
  description: 'Premium workspace with all facilities.',
  images: [],
  facilities: [46, 47, 48],
  pricing_methods: [
    { pricing_type_id: 1, price: 100.0 },
    { pricing_type_id: 2, price: 250.0 },
  ],
  opening_times: {
    sunday: { open: '09:00', close: '19:00' },
    monday: { open: '09:00', close: '19:00' },
    tuesday: { open: '09:00', close: '19:00' },
    wednesday: { open: '09:00', close: '19:00' },
    thursday: { open: '09:00', close: '19:00' },
    friday: { open: '09:00', close: '19:00' },
    saturday: 'closed',
  },
};

export const DEFAULT_ASSET_UPDATE_BODY: Record<string, unknown> = {
  asset_name: 'Updated Asset Name get',
  sub_title: '',
  address: {
    street: '456 Updated St',
    building: '8',
    city: 'Updated City',
    zip_code: '54321',
    address2: 'Updated Address 2',
  },
  country_id: 1,
  state_id: 2,
  asset_type_id: 4,
  latitude: DEFAULT_ASSET_LATITUDE,
  longitude: DEFAULT_ASSET_LONGITUDE,
  min_capacity: 50,
  max_capacity: 100,
  phone_number: '+43345678978',
  email: 'contact1@office.com',
  description: 'Updated description of the asset.',
  facilities: [46, 47],
  pricing_methods: [
    { pricing_type_id: 1, price: 100.0 },
    { pricing_type_id: 2, price: 150.0 },
  ],
  opening_times: {
    sunday: { open: '09:00', close: '19:00' },
    monday: { open: '09:00', close: '19:00' },
    wednesday: { open: '09:00', close: '19:00' },
    friday: { open: '17:00', close: '03:00' },
    saturday: 'closed',
  },
  images: [
    'image236.jpg',
    'image121.jpg',
    'https://storage.googleapis.com/offizz-assets-images-test/a5395c2d-e1f6-4161-9b3e-bd59ceeb64ed/77a20280-71b1-4437-b8a8-2c758edc30ec.jpg',
  ],
};

/** Same structure as the corresponding default body, with fields cleared for the Assets “Clear” action. */
function toEmptyBodyValue(value: unknown): unknown {
  if (value === null || value === undefined) {
    return null;
  }
  if (typeof value === 'string') {
    return '';
  }
  if (typeof value === 'number') {
    return null;
  }
  if (typeof value === 'boolean') {
    return false;
  }
  if (Array.isArray(value)) {
    return [];
  }
  if (typeof value === 'object') {
    const o = value as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const key of Object.keys(o)) {
      out[key] = toEmptyBodyValue(o[key]);
    }
    return out;
  }
  return null;
}

/** Cleared create body (strings empty, numbers null, arrays empty, nested objects cleared). */
export function emptyAssetCreateBody(): Record<string, unknown> {
  const body = toEmptyBodyValue(DEFAULT_ASSET_CREATE_BODY) as Record<string, unknown>;
  body.opening_times = buildDefaultAssetCreateOpeningTimes();
  return body;
}

/** Cleared update body. */
export function emptyAssetUpdateBody(): Record<string, unknown> {
  return toEmptyBodyValue(DEFAULT_ASSET_UPDATE_BODY) as Record<string, unknown>;
}

export function defaultCreateJsonText(): string {
  return JSON.stringify(DEFAULT_ASSET_CREATE_BODY, null, 2);
}

export function defaultUpdateJsonText(): string {
  return JSON.stringify(DEFAULT_ASSET_UPDATE_BODY, null, 2);
}
